import styled from "@emotion/styled";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import { useEffect, useState } from "react";
import { FileType } from "src/api/types";

export const ImagePreview = styled.img`
  display: flex;
  max-width: 100%;
  object-fit: contain;
  width: 100%;
  margin: auto;
`;

interface FilePreviewProps {
  file: FileType["fileToUpload"];
  title: string;
  onRemove: () => void;
}

const FilePreview = ({ file, title, onRemove }: FilePreviewProps) => {
  const [fileUrl, setFileUrl] = useState<string | null>(null);

  useEffect(() => {
    if (fileUrl == null) {
      let url = "";
      if (file instanceof Blob) {
        url = URL.createObjectURL(file);
      } else {
        url = file;
      }

      setFileUrl(url);
    }

    return () => {
      if (fileUrl != null) {
        URL.revokeObjectURL(fileUrl);
      }
    };
  }, [file, fileUrl]);

  return (
    <Box
      overflow="hidden"
      borderRadius="24px"
      width="100%"
      height="280px"
      display="flex"
      justifyContent="center"
      alignItems="center"
      border="1px dashed #1B1B1B"
      position="relative"
    >
      <Box display="flex">
        {fileUrl ? (
          <ImagePreview
            src={fileUrl}
            alt={title || ""}
            width="fit-content"
            height="inherit"
          />
        ) : null}
        <IconButton
          onClick={onRemove}
          sx={{
            position: "absolute",
            top: 0,
            right: 0,
            padding: "4px",
            color: "inherit",
          }}
        >
          <CancelOutlinedIcon fontSize="large" />
        </IconButton>
      </Box>
    </Box>
  );
};

export default FilePreview;
